import { render, staticRenderFns } from "./superviseList.vue?vue&type=template&id=47135da1&scoped=true&"
import script from "./superviseList.vue?vue&type=script&lang=js&"
export * from "./superviseList.vue?vue&type=script&lang=js&"
import style0 from "./superviseList.vue?vue&type=style&index=0&id=47135da1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47135da1",
  null
  
)

export default component.exports